import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { domain } from '../common/domain';

function Purity() {
  const [purities, setPurities] = useState([]);
  const [newPurity, setNewPurity] = useState('');

  // Fetch purities on mount
  useEffect(() => {
    fetchPurities();
  }, []);

  const fetchPurities = async () => {
    try {
      const response = await axios.get(`${domain()}?endpoint=purity`);
      setPurities(response.data);
    } catch (error) {
      console.error('Error fetching purities:', error);
    }
  };

  const handleAddPurity = async () => {
    if (newPurity.trim()) {
      try {
        const formData = new FormData();
        formData.append('name', newPurity);

        await axios.post(`${domain()}?endpoint=purity`, formData);
        setNewPurity('');
        fetchPurities();
      } catch (error) {
        console.error('Error adding purity:', error);
      }
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${domain()}?endpoint=purity&id=${id}`);
      fetchPurities();
    } catch (error) {
      console.error('Error deleting purity:', error);
    }
  };

  const handleEdit = (index) => {
    const updatedPurities = purities.map((p, i) =>
      i === index ? { ...p, isEditing: !p.isEditing } : p
    );
    setPurities(updatedPurities);
  };

  const handleSave = async (id, purity) => {
    try {
      const formData = new FormData();
      formData.append('name', purity);
      formData.append('_method', 'PUT');

      await axios.post(`${domain()}?endpoint=purity&id=${id}&_method=PUT`, formData);
      fetchPurities();
    } catch (error) {
      console.error('Error updating purity:', error);
    }
  };

  const handleInputChange = (index, field, value) => {
    const updatedPurities = purities.map((p, i) =>
      i === index ? { ...p, [field]: value } : p
    );
    setPurities(updatedPurities);
  };

  return (
    <div className="p-3 bg-light text-dark rounded" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h5 className="mb-3 text-center">Purity</h5>
      <div className="d-flex mb-2">
        <input
          type="text"
          className="form-control form-control-sm me-2"
          placeholder="Purity value"
          value={newPurity}
          onChange={(e) => setNewPurity(e.target.value)}
        />
        <button className="btn btn-sm btn-primary" onClick={handleAddPurity}>
          Add
        </button>
      </div>
      <table className="table table-sm table-bordered text-center">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Purity</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {purities.length > 0 ? (
            purities.map((p, index) => (
              <tr key={p.id}>
                <td>{index + 1}</td>
                <td>
                  {p.isEditing ? (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={p.name}
                      onChange={(e) => handleInputChange(index, 'name', e.target.value)}
                    />
                  ) : (
                    p.name
                  )}
                </td>
                <td>
                  {p.isEditing ? (
                    <button
                      className="btn btn-sm btn-success me-1"
                      onClick={() => handleSave(p.id, p.name)}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="btn btn-sm btn-warning me-1"
                      onClick={() => handleEdit(index)}
                    >
                      Edit
                    </button>
                  )}
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(p.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-muted">
                No purity records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Purity;
